export default __webpack_public_path__ + "static/media/longCloud22.8eec57e3.webp";